module.exports = __webpack_public_path__ + "img/forget.8aeee394.svg";